export class ToggleGlobalLoader {
    static readonly type = '[App] Toggle Global Loader';
    constructor(public visible: boolean) {}
}


